import React from 'react';

export const BikePlate = ({ppu}) => {
  const letters = ppu && ppu.match(/[a-zA-Z]+/g).join('');
  const digits = ppu && +ppu.match(/[0-9]+/g).join('');

  return (
    <g id="Group_4199" data-name="Group 4199" transform="translate(105.497 228)">
      <g id="Group_403" data-name="Group 403" transform="translate(0)">
        <g id="Rectangle_16" data-name="Rectangle 16" transform="translate(5)" fill="#fff" stroke="#848484" strokeWidth="1">
          <rect width="92.005" height="37.53" rx="2" stroke="none"/>
          <rect x="0.5" y="0.5" width="91.005" height="36.53" rx="1.5" fill="none"/>
        </g>
        <text id="chile" transform="translate(33.003 11)" fill="#040404" fontSize="7" fontFamily="Inter" letterSpacing="0.5em"><tspan x="0" y="0">CHILE</tspan></text>
        <g id="Group_4198" data-name="Group 4198">
          <text id="_331" data-name="331"
                transform={ (letters || '').length === 3 ? "translate(65 29)" : "translate(49.508 29)" } fill="#040404"
                fontSize="18" fontFamily="Helvetica"
                letterSpacing="0.07em"><tspan x="0" y="0">{digits || ''}</tspan></text>

          <text id="aA" transform="translate(15.008 29)" fill="#040404" fontSize="18" fontFamily="Helvetica" letterSpacing="0.07em"><tspan x="0" y="0">{letters || ''}</tspan></text>

          <g id="Group_4158" data-name="Group 4158" transform={ ( letters || '' ).length === 3 ? "translate(59 22)" : "translate(42.195 22)" }>
            <circle id="Ellipse_1" data-name="Ellipse 1" cx="1.595" cy="1.595" r="1.595"/>
            <g id="insignia-escudo-con-contorno" transform="translate(0.54 0.437)">
              <g id="Group_400" data-name="Group 400" transform="translate(0 0)">
                <path id="Path_187" data-name="Path 187" d="M42.211,27.614c-.29.648.813.659.97,1.068.02.053.017.053.037,0,.157-.409,1.26-.42.97-1.068a.894.894,0,0,1,.055-1.008.045.045,0,0,0,0-.059l-.261-.3a.052.052,0,0,0-.061-.011.85.85,0,0,1-.686-.021.1.1,0,0,0-.072,0,.85.85,0,0,1-.686.021.052.052,0,0,0-.061.011l-.261.3a.045.045,0,0,0,0,.059A.893.893,0,0,1,42.211,27.614Z" transform="translate(-42.145 -26.207)"/>
              </g>
            </g>
            <path id="Path_189" data-name="Path 189" d="M135.273,140.866l-.188.355-.4.069.28.289-.057.4.361-.177.361.177-.057-.4.28-.289-.4-.069Z" transform="translate(-133.686 -139.863)"/>
          </g>

        </g>
      </g>
    </g>
  );
};
